module.exports = __webpack_public_path__ + "img/FIRSILOGO.99a6915c.png";